import markets from '../../@generated/markets.json';
import { LanguageCode } from './languages';
import { CountryCode } from 'shared/@types';

interface Market {
  locale: string;
  country_code: CountryCode;
  country_name: string;
  language_code: LanguageCode;
  language_name: string;
  currency: string;
  calling_code: number;
}

function marketByCountryCode(countryCode?: string | null) {
  return markets.find((market) => market.country_code === countryCode?.toUpperCase()) as
    | Market
    | undefined;
}

function marketByLanguageCode(languageCode: LanguageCode) {
  return markets.find((market) => market.language_code === languageCode) as Market | undefined;
}

export { markets, marketByCountryCode, marketByLanguageCode };
export type { Market };
